module.exports = __webpack_public_path__ + "static/intro-character-9734938027083e9f62b3eb56ad18dbd5.svg";